/**
 * Tracks the newest run of an async operation so that an older, still
 * running invocation can bail out after its awaits instead of applying a
 * stale result.
 */
export function createGenerationGuard(): { next: () => () => boolean } {
  let current = 0;
  return {
    next() {
      const mine = ++current;
      return () => mine !== current;
    },
  };
}
